import React, { useState } from "react";
import "../styles/MembershipList.css";

const MembershipDetails = () => {
  const [selectedPlan, setSelectedPlan] = useState("Gold");

  const plans = [
    {
      name: "Silver",
      price: "3000",
      features: [
        "Access up to 50 profiles",
        "Verified Profiles",
        "Chat Access",
        "Profile Shortlist",
        "Customer Support",
      ],
      popular: false
    },
    {
      name: "Gold",
      price: "5000",
      features: [
        "Access up to 75 profiles",
        "Verified Profiles",
        "Chat Access",
        "Profile Shortlist",
        "Customer Support",
      ],
      popular: true
    },
    {
      name: "Platinum",
      price: "7000",
      features: [
        "Access up to 100 profiles",
        "Verified Profiles",
        "Chat Access",
        "Profile Shortlist",
        "Customer Support",
      ],
      popular: false
    },
  ];

  const handlePaymentRedirect = (plan) => {
    // You can dynamically create the CCAvenue payment link with plan price
    // Here, I'm using a placeholder URL. Replace with actual CCAvenue payment URL or integration link.
    const paymentUrl = `https://www.ccavenue.com/demo/ccavRequestHandler.jsp?amount=${plan.price}&plan=${plan.name}`;
    window.location.href = paymentUrl; // Redirect to CCAvenue
  };

  return (
    <div className="membershipList-plans-container">
      <h2 className="membershipList-plans-title">Membership Details</h2>
      <p className="membershipList-plans-subtitle">
        Manage your plan, check remaining profile access, and renew or upgrade/Degrade.
      </p>

      <div className="membershipList-plans">
        {plans.map((plan, index) => (
          <div 
            className={`membershipList-plan-card ${selectedPlan === plan.name ? 'selected' : ''} ${plan.popular ? 'popular' : ''}`}
            key={index}
            onClick={() => setSelectedPlan(plan.name)}
          >
            {plan.popular && <div className="membershipList-popular-badge">Most Popular</div>}
            
            <h3 className="membershipList-plan-title">Plan Name : {plan.name}</h3>
            <h4 className="membershipList-plan-price">Price : {plan.price}/-</h4>
            <ul className="membershipList-plan-features">
              {plan.features.map((feature, i) => (
                <li key={i}>{feature}</li>
              ))}
            </ul>
            <button 
              className={`membershipList-select-btn ${selectedPlan === plan.name ? 'selected' : ''}`}
              onClick={() => handlePaymentRedirect(plan)} // Redirect to CCAvenue
            >
              {selectedPlan === plan.name ? 'Current Plan' : 'Select Plan'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MembershipDetails;